import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash } from "@phosphor-icons/react";

const INPUT_CLASS =
  "h-9 border-slate-200 bg-white text-slate-900 placeholder:text-slate-400 " +
  "focus:border-emerald-600 focus-visible:ring-emerald-600";

export default function JobWizardAdvancePanel({ entries, onChange }) {
  const update = (index, key, value) => {
    onChange(entries.map((entry, row) => (row === index ? { ...entry, [key]: value } : entry)));
  };
  const add = () => {
    onChange([
      ...entries,
      { amount: "", received_date: new Date().toISOString().slice(0, 10), reference: "", note: "" },
    ]);
  };
  const total = entries.reduce((sum, entry) => sum + (Number(entry.amount) || 0), 0);

  return (
    <section className="space-y-4" data-testid="job-wizard-advance-tab">
      <div className="border border-emerald-200 bg-emerald-50 p-4">
        <h2 className="font-heading text-base font-bold text-emerald-950">Advance received</h2>
        <p className="mt-1 text-xs text-emerald-800">
          Record each advance with its date, reference, and internal note. These entries are saved
          with the job for review.
        </p>
      </div>
      <div className="overflow-x-auto border border-slate-200 bg-white">
        <table className="w-full min-w-[720px] text-sm">
          <thead className="bg-slate-50 text-left text-[10px] font-bold uppercase tracking-wider text-slate-500">
            <tr>
              <th className="w-12 px-3 py-3">#</th>
              <th className="px-3 py-3">Amount (₹)</th>
              <th className="px-3 py-3">Received date</th>
              <th className="px-3 py-3">Reference</th>
              <th className="px-3 py-3">Note</th>
              <th className="w-10 px-2 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {entries.map((entry, index) => (
              <tr key={`${entry.received_date}-${index}`} data-testid={`job-advance-row-${index}`}>
                <td className="px-3 py-2 font-mono text-xs text-slate-500">{index + 1}</td>
                <td className="px-3 py-2">
                  <Input
                    type="number"
                    min="0"
                    value={entry.amount}
                    onChange={(event) => update(index, "amount", event.target.value)}
                    className={INPUT_CLASS}
                    data-testid={`job-advance-amount-${index}`}
                  />
                </td>
                <td className="px-3 py-2">
                  <Input
                    type="date"
                    value={entry.received_date}
                    onChange={(event) => update(index, "received_date", event.target.value)}
                    className={INPUT_CLASS}
                    data-testid={`job-advance-date-${index}`}
                  />
                </td>
                <td className="px-3 py-2">
                  <Input
                    value={entry.reference}
                    onChange={(event) => update(index, "reference", event.target.value)}
                    className={INPUT_CLASS}
                    placeholder="UTR / cheque / receipt no."
                    data-testid={`job-advance-reference-${index}`}
                  />
                </td>
                <td className="px-3 py-2">
                  <Input
                    value={entry.note}
                    onChange={(event) => update(index, "note", event.target.value)}
                    className={INPUT_CLASS}
                    placeholder="Optional note"
                    data-testid={`job-advance-note-${index}`}
                  />
                </td>
                <td className="px-2 py-2">
                  <button
                    type="button"
                    onClick={() => onChange(entries.filter((_, row) => row !== index))}
                    className="p-1.5 text-slate-400 hover:text-rose-600"
                    data-testid={`job-advance-remove-${index}`}
                    aria-label="Remove advance entry"
                  >
                    <Trash size={15} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3 border border-slate-200 bg-white p-3">
        <Button
          type="button"
          onClick={add}
          className="h-8 bg-emerald-600 text-xs text-white hover:bg-emerald-700"
          data-testid="job-advance-add"
        >
          <Plus size={14} /> Add advance entry
        </Button>
        <div className="border border-emerald-200 bg-emerald-50 px-3 py-2 font-mono text-sm font-bold text-emerald-800" data-testid="job-advance-total">
          Total advance: ₹ {total.toLocaleString("en-IN")}
        </div>
      </div>
    </section>
  );
}